/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `en` - en
 * * `fr` - fr
 * * `de` - de
 * @export
 */
export const ConversationalAgentLanguageEnum = {
  en: 'en',
  fr: 'fr',
  de: 'de',
} as const;
export type ConversationalAgentLanguageEnum =
  (typeof ConversationalAgentLanguageEnum)[keyof typeof ConversationalAgentLanguageEnum];

export function instanceOfConversationalAgentLanguageEnum(value: any): boolean {
  for (const key in ConversationalAgentLanguageEnum) {
    if (Object.prototype.hasOwnProperty.call(ConversationalAgentLanguageEnum, key)) {
      if ((ConversationalAgentLanguageEnum as Record<string, ConversationalAgentLanguageEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ConversationalAgentLanguageEnumFromJSON(json: any): ConversationalAgentLanguageEnum {
  return ConversationalAgentLanguageEnumFromJSONTyped(json, false);
}

export function ConversationalAgentLanguageEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentLanguageEnum {
  return json as ConversationalAgentLanguageEnum;
}

export function ConversationalAgentLanguageEnumToJSON(value?: ConversationalAgentLanguageEnum | null): any {
  return value as any;
}
